var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_vm._t("prepend"),_vm._l((_vm.dataList),function(item,i){return [_vm._t("default",null,{"item":item.item,"id":item.key,"index":i})]}),_vm._t("append")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }